<div class="flex flex-col w-full gap-4">
  <div class="px-1 w-full 2xl:w-[95%] mx-auto flex justify-between items-center">
    <div class="px-1 sm:px-2 flex flex-col gap-1 py:4">
      <div class="text-(--color-text-primary) font-semibold text-2xl"></div>
      <div class="text-(--color-text-primary) text-lg font-light"></div>
    </div>

    <div class="flex gap-2">
      <button
        matMiniFab
        class="text-lg bg-transparent! shadow-none! rounded-full! border! border-(--comp-icon-color-secondary)!"
        (click)="changeTable(true)"
      >
        <mat-icon
          class="text-2xl! size-6! text-(--comp-icon-color-secondary)! material-symbols-outlined"
          >border_all</mat-icon
        >
      </button>
      <button
        matMiniFab
        class="text-lg bg-transparent! shadow-none! rounded-full! border! border-(--comp-icon-color-secondary)!"
        (click)="changeTable(false)"
      >
        <mat-icon
          class="text-2xl! size-6! text-(--comp-icon-color-secondary)! material-symbols-outlined"
          >list</mat-icon
        >
      </button>
    </div>
  </div>

  <div class="px-1 w-full 2xl:w-[95%] mx-auto">
    <div class="general-box">
      @if (isTable) {
        <div
          class="grid gap-2 gap-y-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4"
        >
          @for (card of dataAux; track card) {
            <app-card-locations
              class="w-full max-w-100! m-auto"
              [itemLocation]="card"
              (eventLocation)="onEventLocation($event)"
              (eventDetail)="openDetailLocation($event)"
            ></app-card-locations>
          }
          <!-- Tabla General Simple para Ubicaciones -->
        </div>
      } @else {
        <app-table-general
          [headers]="headersLocations"
          [dataSource]="dataSourceLocations"
          [buttonEvent]="true"
          (idEmitter)="openDetailLocation($event)"
          (endElementEmitter)="onEventLocationTable($event)"
          [menuButton]="[
            { icon: 'add_location', key: 'location', text: 'Ver punto de conexión' },
            { icon: 'add_notes', key: 'article', text: 'Alta de solicitud' },
          ]"
        ></app-table-general>
      }
      <mat-paginator
        [length]="totalLocation"
        [pageSize]="pageSize"
        [pageSizeOptions]="[8, 16, 52]"
        [attr.aria-label]="'common.accessibility.selectPage' | translate"
        (page)="changePage($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>

<app-load-general [load]="isLoading"></app-load-general>
